import Vue from "vue"
import { mdiWhatsapp } from '@mdi/js'

import store from '@/store'

import VueMask from 'v-mask'
import { VueMaskFilter } from 'v-mask'
Vue.use(VueMask);

/**
 * Retorna um número formatado como Reais.
 */
Vue.filter('currency', value => {
    if (!value) {
        return '';
    }

    let formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    });

    return formatter.format(value);
})

Vue.filter('formatNumber', (n) => {
    let value = n.toString()
    let ending = ['k', 'm', 'b', 't']
    if (value.length < 4) {
        return value;
    } else {
        return `${value[0]}${value[1] != '0' ? `.${value[1]}` : ''}${ending[Math.floor((value.length - 1) / 3) - 1]}`;
    }
})

/**
 * Formata números de telefone.
 * Remove o código do país (55).
 */
Vue.filter('phoneNumber', value => {
    if (!value) {
        return '';
    }

    if (value.length > 11 && value.startsWith('55')) {
        // Remove o código do país (55)
        value = value.slice(2);
    }

    if (value.length === 10) {
        return VueMaskFilter(value, '(##) ####-####');
    } else if (value.length === 11) {
        return VueMaskFilter(value, '(##) #####-####');
    }

    return value;
})

/**
 * Gateways/brokers dos canais.
 */
Vue.filter('serviceSource', value => {
    return {
        'infobip': 'Infobip',
        'otima': 'Ótima',
        'pgmais': 'PGMais',
        'pointer': 'Pontal',
        'twilio': 'Twilio',
        'zenvia': 'Zenvia',
    }[value] || value;
})

/**
 * Tipos de canal.
 * 
 * https://github.com/quiteja/rasa-api/blob/6721c87f62249e6beca23bbfcab711d0315df7c8/rasa_api/model.py#L271
 */
Vue.filter('serviceType', value => {
    return {
        'EMAIL': 'E-mail',
        'SITE': 'Site',
        'SMS': 'SMS',
        'WHATSAPP': 'WhatsApp',
    }[value] || value;
})

/**
 * Ícones para cada tipo de canal.
 * 
 * Copiado de https://github.com/quiteja/dodo-app-web/blob/0a98bcf18e83193520386a702ccddffb210c81c1/src/components/Common/Menu.vue#L134-L150
 */
Vue.filter('serviceTypeIcon', value => {
    return {
        'EMAIL': 'email',
        'SITE': 'language',
        'SMS': 'sms',
        'WHATSAPP': mdiWhatsapp,
    }[value] || 'info';
})

/**
 * Tipos de conversas.
 * 
 * https://github.com/quiteja/rasa-api/blob/f1e5214af5d2c4fd74215c3f3babb68aac349630/rasa_api/model.py#L55
 */
Vue.filter('sessionSourceType', value => {
    return {
        'AT': 'Atendimento',
        'RA': 'Reclame Aqui',
        'ST': 'Estímulos',
    }[value] || value;
})

Vue.filter('VMask', VueMaskFilter)
Vue.filter('document', value => {
    var str = value + '';

    if (str.length <= 11) {
        str = str.replace(/\D/g, '')
        str = str.replace(/(\d{3})(\d)/, "$1.$2")
        str = str.replace(/(\d{3})(\d)/, "$1.$2")
        str = str.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    }
    else if (str.length > 11 && str.length <= 14) {
        str = str.replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})([a-zA-Z0-9]{2})/, "$1.$2.$3/$4-$5");
    }

    return str;
})

Vue.filter('firstName', value => {
    if (!value) {
        return value
    }
    let splited = value.split(' ')
    if (splited.length > 1) {
        return splited[0] + ' ' + splited[splited.length - 1];
    } else {
        return splited[0]
    }
})

Vue.filter('firstName2', value => {
    if (!value) {
        return value
    }
    let splited = value.split(' ')
    return splited[0]
})

Vue.filter('json', value => {
    if (!value) {
        return value
    }
    return JSON.stringify(value, null, 2);
})

Vue.filter('keyToName', value => {
    if (!value) {
        return value
    }
    let strReplaced = value.split('_').join(' ')
    return strReplaced.charAt(0).toUpperCase() + strReplaced.slice(1)
})

// https://github.com/quiteja/rasa-api/blob/b8f988d47db920e5e1fe3d97fc0f74f810ffd8c1/rasa_api/model.py#L341
Vue.filter('conversationStatus', value => {
    switch (value) {
        case 'AUTO':
            return 'Automático'
        case 'CLOSING':
            return 'Fechando'
        case 'OPENED':
            return 'Aberto'
        case 'PENDING':
            return 'Pendente'
        case 'REOPENED':
            return 'Reaberto'
        case 'WAITING_CUSTOMER':
            return 'Aguardando cliente'
        case 'CLOSED':
            return 'Fechado'
        case 'WAITING_TREATMENT':
            return 'Aguardando tratamento'
        case 'RESOLVED':
            return 'Resolvido'
        case 'DISCARDED':
            return 'Descartado'
        default:
            return value
    }
})

Vue.filter('dealStatus', value => {
    switch (value) {
        case 'CREATED':
            return 'Criada';
        case 'STARTED':
            return 'Iniciada';
        case 'WAITING':
            return 'Aguardando';
        case 'AGREED':
            return 'Aceita';
        case 'RESOLVED':
            return 'Finalizada';
        case 'ABORTED':
            return 'Abortada';
        case 'RENEGOTIATED':
            return 'Renegociado';
        default:
            return value;
    }
})

Vue.filter('dealWaitingCause', value => {
    return {
        'EXISTING_PROMISE': 'Promessa existente',
        'NOT_ELEGIBLE': 'Não elegível',
        'SYNC': 'Sincronização',
    }[value] || value;
})

Vue.filter('firstLetter', value => {
    if (!value) {
        return value
    }
    return value.length ? value[0] : value
})

Vue.filter('percentage', function (value, decimalPlaces) {
    if (!decimalPlaces) {
        decimalPlaces = 0
    }
    return (parseFloat(value) * 100).toFixed(decimalPlaces) + "%"
})

Vue.filter('limitTo', function (value, limit) {
    if (!value) {
        return value
    }
    return value.substring(0, limit)
})

Vue.filter('truncate', function (value, limit) {
    if (!value) {
        return value
    }
    return value.length > limit ? value.substring(0, limit) + '...' : value
})
Vue.filter('IntentName', value => value.name)